import React, { memo, useMemo } from "react";
import { LogContentProps } from "../types";
import { formatLogContent } from "../utils/logFormatter";
import "./LogContent.css";

/**
 * Displays log content with optional wrapping and JSON prettification
 * Handles ANSI color codes and HTML sanitization
 */
export const LogContent = memo(function LogContent({
  text,
  wrap,
  prettifyJSON,
}: LogContentProps) {
  const formattedContent = useMemo(() => {
    return formatLogContent(text, { prettifyJson: prettifyJSON });
  }, [text, prettifyJSON]);

  // For prettified JSON, we need to convert newlines to <br> for display
  const displayContent = useMemo(() => {
    if (prettifyJSON) {
      return formattedContent.replace(/\n/g, "<br>").replace(/  /g, "&nbsp;&nbsp;");
    }
    return formattedContent;
  }, [formattedContent, prettifyJSON]);

  return (
    <div
      className={`log-content ${wrap ? "log-content--wrap" : "log-content--nowrap"}`}
      dangerouslySetInnerHTML={{ __html: displayContent }}
    />
  );
});
